(function () {
    'use strict';

    angular
        .module('blocks.smart')
        .directive('smartCheck', smartCheck);

    /* @ngInject */
    function smartCheck() {
        // allows us to have a checkbox filter on smart tables.
        // Usage:
        //  <smart-check predicate="someCheckboxField"></smart-select>
        // Creates:
        //  <smart-select predicate="someCheckboxField">
        //  <select><select>
        //  </smart-select>
        var directive = {
            link: link,
            require: '^stTable',
            scope: {
                predicate: '@'
            },
            template: '' +
                '<input type="checkbox" ng-model="sel" ng-change="stCheckChange()"> '
        };
        return directive;

        function link(scope, element, attr, table) {
            scope.stCheckChange = function stCheckChange() {
                if (scope.sel) {
                    table.search(scope.sel, scope.predicate);
                } else {
                    // SmartTable search mechanism will throw out the search term if it is falsey
                    table.search('false', scope.predicate);
                }
            };

            scope.$watch(
                function watch(scope) {
                    if (!!table.tableState().search.predicateObject) {
                        return (table.tableState().search.predicateObject[scope.predicate]);
                    }
                }, function (newValue) {
                    if (typeof newValue === 'undefined') {
                        scope.sel = undefined;
                    }
                },
                true);

        }
    }
})();

